import React, { useState, useEffect, useCallback } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import { useAuth } from '../../hooks/Auth';

import {
  Container,
  EventsContainer,
  Event,
  Pagination,
  CustomLink,
} from './styles';
import { useHeader } from '../../hooks/Header';
import fightApiV2 from '../../services/fightApiV2';

interface Event {
  id: string;
  legacyId: number;
  oneEventId?: string;
  name: string;
  time: string;
  location: string;
  venueId: number;
  date: Date;
  promotionId: number;
}

const Events: React.FC = () => {
  const [limit] = useState(9);
  const [page, setPage] = useState(0);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { dispatchHeader } = useHeader();
  const { token } = useAuth();

  useEffect(() => {
    async function fetchEvents() {
      setLoading(true);
      dispatchHeader({
        title: 'Eventos',
        eventName: '',
        leftBg: {
          r: 51,
          g: 102,
          b: 255,
          a: 1,
        },
        rightBg: {
          r: 255,
          g: 255,
          b: 255,
          a: 1,
        },
        hasLogout: true,
        isScout: false,
      });
      try {
        const response = await fightApiV2.get(`/events`, {
          headers: {
            per_page: limit,
            page,
          },
        });

        setEvents(response.data.data);
      } catch (err) {
        toast.error('Fetch events failed.');
        setEvents([]);
      } finally {
        setLoading(false);
      }
    }

    fetchEvents();
  }, [page, limit, token, dispatchHeader]);

  const handleNextPagination = useCallback(() => {
    setPage(page + 1);
  }, [page]);

  const handlePreviousPagination = useCallback(() => {
    if (page >= 1) setPage(page - 1);
  }, [page]);
  return (
    <Container>
      <ToastContainer />
      <Pagination>
        <span className="arrow" onClick={handlePreviousPagination}>
          {'<'}
        </span>
        <span>{page + 1}</span>
        <span className="arrow" onClick={handleNextPagination}>
          {'>'}
        </span>
      </Pagination>

      <EventsContainer>
        {!loading && !events.length && <span>No events found.</span>}

        {loading ? (
          <SkeletonTheme color="#1111" highlightColor="#d3d3d3">
            <Skeleton height={180} width={400} count={6} />
          </SkeletonTheme>
        ) : (
          events.map((e: Event) => (
            <Event key={e.id}>
              <strong className="event-name">{e.name}</strong>
              <span className="event-location">{e.location}</span>
              <span className="event-time">{e.time}</span>

              <CustomLink to={`/events/${e.id}/fights`}>Lutas</CustomLink>
            </Event>
          ))
        )}
      </EventsContainer>
    </Container>
  );
};

export default Events;
